"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".payment-less[_ngcontent-%COMP%]{color:red}.payment-more[_ngcontent-%COMP%]{color:#444a50}.no-padding[_ngcontent-%COMP%]{padding:0}.hidden[_ngcontent-%COMP%]{display:none}"];
exports.styles = styles;
